module.exports = "query LoggedInQuery{loggedIn}"